<template>
  <com-page>
    <com-card>
      <div class="mb-20px">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="1"></el-tab-pane>
          <el-tab-pane label="分成设置" name="2"></el-tab-pane>
        </el-tabs>
      </div>
      <el-descriptions title="" :column="4" v-if="activeName === '1'">
        <el-descriptions-item label="小区编号">{{ detail.number }}</el-descriptions-item>
        <el-descriptions-item label="小区名称">{{ detail.name }}</el-descriptions-item>
        <el-descriptions-item label="所在区域">{{ detail.areaNames }}</el-descriptions-item>
        <el-descriptions-item label="场地类型">{{ detail.storeTypeName }}</el-descriptions-item>
        <el-descriptions-item label="小区地址">{{ detail.address }}</el-descriptions-item>
        <el-descriptions-item label="电费成本（元/度）">{{ detail.costElectricCharge }}</el-descriptions-item>
        <el-descriptions-item label="租金（元）">{{ detail.rent }}</el-descriptions-item>
        <el-descriptions-item label="服务费（元）">{{ detail.serviceCharge }}</el-descriptions-item>
        <el-descriptions-item label="负责人">{{ detail.projectLeader }}</el-descriptions-item>
        <el-descriptions-item label="小区生效时间">{{ detail.effectiveTime }}</el-descriptions-item>
        <el-descriptions-item label="到期时间">{{ detail.expireTime }}</el-descriptions-item>
        <el-descriptions-item label="限定最高功率（w）">{{ detail.limitMaxPower }}</el-descriptions-item>
        <el-descriptions-item label="最高充电时长（小时）">{{ detail.limitMaxHour }}</el-descriptions-item>
        <el-descriptions-item label="网点数">{{ detail.storeCount }}</el-descriptions-item>
        <el-descriptions-item label="设备数">{{ detail.deviceNums }}</el-descriptions-item>
        <el-descriptions-item label="充电口数">{{ detail.portNums }}</el-descriptions-item>
        <el-descriptions-item label="订单数">{{ detail.orderCount }}</el-descriptions-item>
        <el-descriptions-item label="营业额（元）">{{ detail.turnover }}</el-descriptions-item>
        <el-descriptions-item label="归属">{{ detail.refBelongAgentName }}</el-descriptions-item>
        <el-descriptions-item label="商家">{{ detail.refBelongBusinessName }}</el-descriptions-item>
        <el-descriptions-item label="电量（度）">{{ detail.powerConsumption }}</el-descriptions-item>
        <el-descriptions-item label="用户数">{{ detail.xdUserCount }}</el-descriptions-item>
        <el-descriptions-item label="收费标准">
          <div class="flex">
            {{ detail.chargePlanName }}
            <el-button type="text" size="mini" style="padding: 0 7px" @click="openFeeStandards">查看</el-button>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="充值套餐">{{ detail.rechargePlanBatchName }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{ detail.refCreateUserName }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detail.createTime }}</el-descriptions-item>
        <el-descriptions-item label="合同">
          <a :href="detail.file | filterImage">点击下载</a>
        </el-descriptions-item>
      </el-descriptions>
      <DivvySettingList v-if="activeName === '2'" ref="divvySettingListRef" :communityCode="detail.code"></DivvySettingList>
    </com-card>

    <FeeStandardsList ref="feeStandardsListRef"></FeeStandardsList>
  </com-page>
</template>

<script>
import { communityDetailApi } from '@/api/community'
import FeeStandardsList from './components/fee-standards-list'
import DivvySettingList from './components/divvy-setting-list'

export default {
  components: { FeeStandardsList, DivvySettingList },

  data() {
    return {
      code: '',
      activeName: '1',
      detail: {},
    }
  },

  created() {
    this.code = this.$route.query.code
    console.log('route :>> ', this.detail)
    this.getDetail()
  },

  methods: {
    getDetail() {
      communityDetailApi({code: this.code}).then((res) => {
        console.log('详情 :>> ', res.data)
        this.detail = res.data.result
      })
    },

    openFeeStandards() {
      this.$refs.feeStandardsListRef.open(this.detail)
    }
  },
}
</script>

<style lang="scss" scoped></style>
